import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Alginment, EMPTY_STRING, LoadingMessages, MAX_RECORD } from "src/app/common/Const";
import { MI100001, MI200003, MQ200010 } from "src/app/common/const-message-id";
import { GC_D0046_CANCELLED, GC_D0046_VALID, GC_D2016_CORR_SLIP, GC_D2016_NORMAL_SLIP, GC_D2087_APPROVED, GC_D2087_REJECTED, GC_D2087_REQUESTING } from "src/app/common/ConstCcd";
import { GC_H0046_SLIP_CANCEL_FLAG, GC_H2016_SLIP_CORR_TYPE, GC_H2087_APPL_STATUS_DSP } from "src/app/common/ConstCcdDef";
import { TableColumnDef } from "src/app/common/table-column-def";
import { Spmt10321ConfirmDialogComponent } from "src/app/dialog/spmt10321-confirm-dialog/spmt10321-confirm-dialog.component";
import { Spmt10321DetailDialogComponent } from "src/app/dialog/spmt10321-detail-dialog/spmt10321-detail-dialog.component";
import { Req } from "src/app/request/req";
import { ReqAccess } from "src/app/request/req-access";
import { ReqGetStoreList } from "src/app/request/req-get-store-list";
import { Spmt10321DetailCommentDto } from "src/app/request/req-spmt10321-confirm";
import { ReqSpmt10321Search } from "src/app/request/req-spmt10321-search";
import { DropdownListOfUserDto } from "src/app/response/rsp-get-dropdown-list-of-user";
import { GetStoreListDto } from "src/app/response/rsp-get-store-list";
import { Spmt10321SearchRowDto } from "src/app/response/rsp-spmt10321-search";
import { KbnSearchDto } from "src/app/response/rsp-tmt050-all-kbn-search";
import { CommonService } from "src/app/service/common.service";
import { HttpBasicService } from "src/app/service/http-basic.service";
import { MessageService } from "src/app/service/message.service";
import { ValidateService } from "src/app/service/validate.service";

export enum ColumnIds {
  Checkbox = "checkbox",
  SlipNo = "slipNo",
  StoreCd = "storeCd",
  StoreNm = "storeNm",
  DisposalDate = "disposalDate",
  ReqStatusNm = "reqStatusNm",
  RedBlackNm = "redBlackNm",
  SlipCancelNm = "slipCancelNm",
  DtQtyTotal = "dtQtyTotal",
  CostAmtExcTotal = "costAmtExcTotal",
  SellPriceAmtExcTotal = "sellPriceAmtExcTotal",
  SlipCreateDate = "slipCreateDate",
  SlipApproveDate = "slipApproveDate",
  SlipChangeDate = "slipChangeDate",
  SlipCancelDate = "slipCancelDate",
  RequesterCd = "requesterCd",
  ApproverCd = "approverCd",
  SlipComment = "slipComment",
  ApproverComment = "approverComment",
}

export enum ColumnHeaders {
  Checkbox = "選択",
  SlipNo = "伝票番号",
  StoreCd = "店舗コード",
  StoreNm = "店舗名称",
  DisposalDate = "廃棄日",
  ReqStatusNm = "申請状態",
  RedBlackNm = "赤黒区分",
  SlipCancelNm = "伝票取消フラグ",
  DtQtyTotal = "数量合計",
  CostAmtExcTotal = "原価金額合計(抜)",
  SellPriceAmtExcTotal = "売価金額合計(抜)",
  SlipCreateDate = "伝票登録日",
  SlipApproveDate = "伝票承認日",
  SlipChangeDate = "伝票訂正日",
  SlipCancelDate = "伝票取消日",
  RequesterCd = "申請者",
  ApproverCd = "承認者",
  SlipComment = "申請者コメント",
  ApproverComment = "承認者コメント",
}

interface TableRow extends Spmt10321SearchRowDto {
  form: {
    checkFormCtrl: FormControl;
  };
  details: Spmt10321DetailCommentDto[];
  isDisableRow: boolean;
}

class Constant {
  public static readonly STORE_CD_CTRL = "storeCd";
  public static readonly SLIP_NO_CTRL = "slipNo";
  public static readonly SLIP_CREATE_DATE_FROM_CTRL = "slipCreateDateFrom";
  public static readonly SLIP_CREATE_DATE_TO_CTRL = "slipCreateDateTo";
  public static readonly REQ_STATUS_CTRL = "reqStatus";
  public static readonly REQUESTER_CD_CTRL = "requesterCd";
  public static readonly APPROVER_CD_CTRL = "approverCd";
  public static readonly SLIP_CANCEL_FLG_CTRL = "slipCancelFlg";
  public static readonly RED_BLACK_FLG_CTRL = "redBlackFlg";
}

@Component({
  selector: "app-spmt10321",
  templateUrl: "./spmt10321.component.html",
  styleUrls: ["./spmt10321.component.css"],
})
export class Spmt10321Component implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  access: ReqAccess = {
    ...this.commonService.loginUser,
  };

  dataSource: MatTableDataSource<TableRow> = new MatTableDataSource<TableRow>([]);
  checkAllFormCtrl: FormControl = new FormControl(false);
  storeSearchConditions: any = {};
  itemRecordCount: number = 0;

  columnIds: string[] = [
    ColumnIds.Checkbox,
    ColumnIds.SlipNo,
    ColumnIds.StoreCd,
    ColumnIds.StoreNm,
    ColumnIds.DisposalDate,
    ColumnIds.ReqStatusNm,
    ColumnIds.RedBlackNm,
    ColumnIds.SlipCancelNm,
    ColumnIds.DtQtyTotal,
    ColumnIds.CostAmtExcTotal,
    ColumnIds.SellPriceAmtExcTotal,
    ColumnIds.SlipCreateDate,
    ColumnIds.SlipApproveDate,
    ColumnIds.SlipChangeDate,
    ColumnIds.SlipCancelDate,
    ColumnIds.RequesterCd,
    ColumnIds.ApproverCd,
    ColumnIds.SlipComment,
    ColumnIds.ApproverComment,
  ];

  columnDefs: TableColumnDef[] = [
    { columnId: ColumnIds.Checkbox, header: ColumnHeaders.Checkbox, width: 40, align: Alginment.Center, checkbox: true },
    { columnId: ColumnIds.SlipNo, header: ColumnHeaders.SlipNo, width: 80, align: Alginment.Left, editable: true },
    { columnId: ColumnIds.StoreCd, header: ColumnHeaders.StoreCd, width: 70, align: Alginment.Left },
    { columnId: ColumnIds.StoreNm, header: ColumnHeaders.StoreNm, width: 100, align: Alginment.Left },
    { columnId: ColumnIds.DisposalDate, header: ColumnHeaders.DisposalDate, width: 75, align: Alginment.Left },
    { columnId: ColumnIds.ReqStatusNm, header: ColumnHeaders.ReqStatusNm, width: 65, align: Alginment.Left },
    { columnId: ColumnIds.RedBlackNm, header: ColumnHeaders.RedBlackNm, width: 60, align: Alginment.Left },
    { columnId: ColumnIds.SlipCancelNm, header: ColumnHeaders.SlipCancelNm, width: 90, align: Alginment.Left },
    { columnId: ColumnIds.DtQtyTotal, header: ColumnHeaders.DtQtyTotal, width: 70, align: Alginment.Right, numberPipe: "1.0-0" },
    { columnId: ColumnIds.CostAmtExcTotal, header: ColumnHeaders.CostAmtExcTotal, width: 100, align: Alginment.Right, numberPipe: "1.0-0" },
    { columnId: ColumnIds.SellPriceAmtExcTotal, header: ColumnHeaders.SellPriceAmtExcTotal, width: 100, align: Alginment.Right, numberPipe: "1.0-0" },
    { columnId: ColumnIds.SlipCreateDate, header: ColumnHeaders.SlipCreateDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.SlipApproveDate, header: ColumnHeaders.SlipApproveDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.SlipChangeDate, header: ColumnHeaders.SlipChangeDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.SlipCancelDate, header: ColumnHeaders.SlipCancelDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.RequesterCd, header: ColumnHeaders.RequesterCd, width: 100, align: Alginment.Left },
    { columnId: ColumnIds.ApproverCd, header: ColumnHeaders.ApproverCd, width: 100, align: Alginment.Left },
    { columnId: ColumnIds.SlipComment, header: ColumnHeaders.SlipComment, width: 180, align: Alginment.Left },
    { columnId: ColumnIds.ApproverComment, header: ColumnHeaders.ApproverComment, width: 180, align: Alginment.Left },
  ];

  storeList: GetStoreListDto[] = [];
  userList: DropdownListOfUserDto[] = [];
  reqStatusList: KbnSearchDto[] = [];
  slipCancelList: KbnSearchDto[] = [];
  redBlackList: KbnSearchDto[] = [];

  itemTableWidth: any;
  tableHeight: number = 381;
  searchCondition: FormGroup;
  constructor(public commonService: CommonService, public httpBasic: HttpBasicService, private readonly message: MessageService, private readonly fb: FormBuilder) {
    this.searchCondition = this.fb.group({
      requesterCd: [""],
      slipNo: [""],
      storeCd: ["", Validators.required],
      reqStatus: fb.array([], [ValidateService.atLeastOneCheckedValidator()]),
      slipCancelFlg: [GC_D0046_VALID],
      slipCreateDateFrom: [""],
      slipCreateDateTo: [""],
      approverCd: [""],
      redBlackFlg: [GC_D2016_NORMAL_SLIP],
    });
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.commonService.pageTitle = this.commonService.pageMenuName;
    this.fnGetAccessInfo();
    this.calcTableWidth();
  }

  initScreen() {
    this.getUserLists();
    this.getStoreList();
    this.getKbnList(() => {
      const reqStatus: FormArray = this.searchCondition.get(Constant.REQ_STATUS_CTRL) as FormArray;
      this.reqStatusList.forEach((item) => {
        const isTrue = item.kbn === GC_D2087_REQUESTING;
        reqStatus.push(new FormControl(isTrue));
      });
      this.checkRedirectAlert();
    });
  }

  getKbnList(callBack: () => void) {
    const rcdKbns = [GC_H2087_APPL_STATUS_DSP, GC_H2016_SLIP_CORR_TYPE, GC_H0046_SLIP_CANCEL_FLAG];
    const request = {
      access: this.access,
      rcdKbns,
    };
    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    return this.httpBasic.tmt050AllKbnSearch(request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.redBlackList = res.rows.filter((row) => row.rcdKbn === GC_H2016_SLIP_CORR_TYPE);
        this.reqStatusList = res.rows.filter((row) => row.rcdKbn === GC_H2087_APPL_STATUS_DSP);
        this.slipCancelList = res.rows.filter((row) => row.rcdKbn === GC_H0046_SLIP_CANCEL_FLAG);
        callBack();
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  private getStoreList() {
    let request: ReqGetStoreList = {
      access: this.access,
      storeCd: EMPTY_STRING,
      userId: EMPTY_STRING,
      cmpyCd: this.access.cmpnyCd,
      sysModeCd: this.access.sysModeCd,
    };

    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    this.httpBasic.getStoreList(request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.storeList = res.rows;
        this.searchCondition.get(Constant.STORE_CD_CTRL).setValue(this.access.storeCd);
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  getUserLists() {
    let request: Req = {
      access: this.commonService.loginUser,
    };
    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    this.httpBasic.generalRequest("GetUserList", request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.userList = res.rows;
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  private checkRedirectAlert() {
    const state = history.state;
    const reqStatus = state?.reqStatus;
    const slipCancelFlg = state?.slipCancelFlg;
    const storeCd = state?.storeCd;
    if (reqStatus || slipCancelFlg || storeCd) {
      if (reqStatus != undefined) {
        const reqStatuses = reqStatus.split(',');
        const reqStatusFormArr = this.searchCondition.get(Constant.REQ_STATUS_CTRL) as FormArray;
        reqStatusFormArr.controls.forEach((control: FormControl, index: number) => {
          const isChecked = reqStatuses.includes(this.reqStatusList[index]?.kbn);
          control.setValue(isChecked);
        });
      }
      if (slipCancelFlg) {
        this.searchCondition.get(Constant.SLIP_CANCEL_FLG_CTRL).setValue(slipCancelFlg);
      }
      if (storeCd) {
        this.searchCondition.get(Constant.STORE_CD_CTRL).setValue(storeCd);
      }
      this.btnSearchClick();
    }
  }

  btnClearClick() {
    if (this.dataSource.data.length > 0) {
      this.commonService.openYesNoDialog(this.commonService.pageTitle, this.message.message[MQ200010]).subscribe((result) => {
        if (result) {
          this.fnClear();
        }
      });
      return;
    }
    this.fnClear();
  }

  private fnClear() {
    this.searchCondition.reset();
    this.checkAllFormCtrl.setValue(false);
    this.searchCondition.get(Constant.STORE_CD_CTRL).setValue(this.access.storeCd);
    this.dataSource.data = [];
    this.searchCondition.get(Constant.SLIP_CANCEL_FLG_CTRL).setValue(GC_D0046_VALID);
    this.searchCondition.get(Constant.RED_BLACK_FLG_CTRL).setValue(GC_D2016_NORMAL_SLIP);
    const reqStatus: FormArray = this.searchCondition.get(Constant.REQ_STATUS_CTRL) as FormArray;
    this.reqStatusList.forEach((item, i) => {
      const isTrue = item.kbn === GC_D2087_REQUESTING;
      reqStatus.controls[i].setValue(isTrue);
    });
  }

  /**
   * calcTableWidth
   */
  calcTableWidth() {
    this.itemTableWidth = { width: "100%" };
  }

  btnSearchClick() {
    if (!this.searchCondition.valid) {
      return;
    }
    let reqStatus: string[] = [];
    const reqStatusFormArray = this.searchCondition.get(Constant.REQ_STATUS_CTRL) as FormArray;
    this.reqStatusList.forEach((item, i) => {
      if (reqStatusFormArray.value[i]) {
        reqStatus.push(item.kbn);
      }
    });
    this.storeSearchConditions = {
      slipNo: this.searchCondition.get(Constant.SLIP_NO_CTRL).value,
      storeCd: this.searchCondition.get(Constant.STORE_CD_CTRL).value,
      requesterCd: this.searchCondition.get(Constant.REQUESTER_CD_CTRL).value,
      reqStatus: reqStatus,
      slipCancelFlg: this.searchCondition.get(Constant.SLIP_CANCEL_FLG_CTRL).value,
      slipCreateDateFrom: this.commonService.dateToString(this.searchCondition.get(Constant.SLIP_CREATE_DATE_FROM_CTRL).value),
      slipCreateDateTo: this.commonService.dateToString(this.searchCondition.get(Constant.SLIP_CREATE_DATE_TO_CTRL).value),
      approverCd: this.searchCondition.get(Constant.APPROVER_CD_CTRL).value,
      redBlackFlg: this.searchCondition.get(Constant.RED_BLACK_FLG_CTRL).value,
    };
    this.fnSearch();
  }

  private fnSearch() {
    this.checkAllFormCtrl.setValue(false);
    const req: ReqSpmt10321Search = {
      access: this.access,
      ...this.storeSearchConditions,
      pageInfo: { pageNum: 0, dispNum: MAX_RECORD + 1 },
    };
    this.httpBasic.beforeRequestStart(LoadingMessages.Searching);
    this.httpBasic.spmt10321Search(req).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        if (res.rows.length === 0) {
          this.commonService.openNotificationDialog(this.commonService.pageTitle, this.message.message[MI100001]);
          this.dataSource.data = [];
          return;
        }
        if (res.rows.length > MAX_RECORD) {
          this.commonService.openNotificationDialog(this.commonService.pageTitle, this.message.message[MI200003].replace("%1", MAX_RECORD).replace("%1", MAX_RECORD));
        }
        this.dataSource.data = res.rows.slice(0, MAX_RECORD).map((item) => ({
          ...item,
          isDisableRow: this.isRowDisabled(item),
          form: {
            checkFormCtrl: new FormControl({ value: false, disabled: this.isRowDisabled(item) }),
          },
          details: [],
        }));
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  isRowDisabled(row: Spmt10321SearchRowDto | TableRow): boolean {
    return row.slipCancelFlg === GC_D0046_CANCELLED || row.redBlackFlg === GC_D2016_CORR_SLIP || row.reqStatus !== GC_D2087_REQUESTING;
  }

  onClickLink(row: TableRow) {
    const dialogRef = this.commonService.dialog.open(Spmt10321DetailDialogComponent, {
      autoFocus: false,
      data: {
        ...row,
        access: this.access,
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        row.details = data;
      }
    });
  }

  fnGetAccessInfo() {
    let req: Req = {
      access: this.access,
    };
    this.httpBasic.beforeRequestStart();
    this.httpBasic.getUserInfo(req).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        if (res.rows.length > 0) {
          this.access.cmpnyCd = res.rows[0].mainCmpnyCd;
          this.access.storeCd = res.rows[0].mainStoreCd;
          this.access.sysModeCd = res.rows[0].sysModeCd;
          this.access.lang = res.rows[0].mainLang;
          this.searchCondition.get(Constant.STORE_CD_CTRL).setValue(this.access.storeCd);
          this.initScreen();
        }
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  onChangeRowCheck() {
    this.checkAllFormCtrl.setValue(this.dataSource.data.filter((item) => !item.isDisableRow).every((item) => item.form.checkFormCtrl.value));
  }

  checkAll($event: any): void {
    this.dataSource.data.forEach((item) => {
      if (!item.isDisableRow) item.form.checkFormCtrl.setValue($event.checked);
    });
  }

  get GC_D2087_APPROVED(): string {
    return GC_D2087_APPROVED;
  }

  get GC_D2016_CORR_SLIP(): string {
    return GC_D2016_CORR_SLIP;
  }

  get GC_D2087_REJECTED(): string {
    return GC_D2087_REJECTED;
  }

  isDisableBtnConfirm() {
    return this.dataSource.data.length === 0 || this.dataSource.data.every((item) => !item.form.checkFormCtrl.value);
  }

  btnConfirmClick(confirmKbn: string): void {
    const dialogRef = this.commonService.dialog.open(Spmt10321ConfirmDialogComponent, {
      autoFocus: false,
      data: {
        rows: this.dataSource.data.filter((item) => item.form.checkFormCtrl.value),
        access: this.access,
        confirmKbn: confirmKbn,
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.fnSearch();
      }
    });
  }

  isCheckboxAllDisabled() {
    return this.dataSource.data.length === 0 || this.dataSource.data.every((item) => item.isDisableRow);
  }
}
